import React, { useContext, useState } from "react";
import { useCookies } from "react-cookie";
import {
  Modal,
  ModalBody,
  ModalContent,
  ModalOverlay,
  ModalFooter,
  Text,
  Flex,
  Image,
  Button
} from "@chakra-ui/react";
import "../assets/css/slickCustom.css";
import Slider from "react-slick";
import { styled } from "styled-components";
import { ScreenContext } from "./ScreenProvider";
import { ReactComponent as IconClose } from "../assets/icons/icon-close.svg";
import { ReactComponent as IconCheck } from "../assets/icons/icon-check.svg";
import { Link } from "react-router-dom";
import bg001 from "../assets/images/popup-pc-003.png";
import bg002 from "../assets/images/popup-pc-002.png";
import bgAitest from "../assets/images/banner/content/bg-aitest.png";
import tAitest from "../assets/images/banner/content/bg-tablet-aitest.png";
import mAitest from "../assets/images/banner/content/bg-mobile-aitest.png";


const BtnClose = styled(IconClose)`
  stroke: #ffffff;
  width: 38px;
  height: 38px;
  cursor: pointer;
`;

const Check = styled.input`
  display: none;
  &:checked + label {
    border: 1px solid #F24B91;
    background-color: #F24B91;
  }
`;

const Label = styled.label<{ $size: string }>`
  width: ${(props) => props.$size};
  height: ${(props) => props.$size};
  border: 1px solid #ffffff;
  border-radius: 3px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 10px;
`;

const CustomSlider = styled(Slider)`
  .slick-dots li button:before {
    color: white; /* 비활성 점의 색상을 하얀색으로 변경 */
  }
  .slick-dots li.slick-active button:before {
    color: white; /* 활성 점의 색상도 하얀색으로 변경 */
  }
`;

const AitestMenu = {
                       path: "testops",
                       name: "TestOps",
                       to: "/testops",
                       desc: { title: "AI 기반 검증 자동화", desc: ``, tag: [], },
                       bg: {
                         pc: bgAitest,
                         mobile: mAitest,
                         tablet: tAitest,
                       },
                       children: [
                        {
                           path: "aitest",
                           name: "AI 기반 자동 검증화",
                           to: "/testops",
                           desc: { title: "AI 기반 검증 자동화", desc: ``, tag: [], },
                           show: true,
                           bg: {
                             pc: bgAitest,
                             mobile: mAitest,
                             tablet: tAitest,
                           }
                         }
                     ]
                 }

interface IPopup {
  item: any;
}

const PopupBanner: React.FC<IPopup> = ({ item }) => {
  const screen = useContext(ScreenContext).style;
  const [showPopup, setShowPopup] = useState<boolean>(true);
  const [cookies, setCookie] = useCookies([`hide${item?.id}`]);
  const [isHidden, setIsHidden] = useState<boolean>(false);
  const [currentIndex, setCurrentIndex] = useState<number>(0);

  const images = [bg001, bg002]; // 추가된 이미지 배열

  const handleHidePopup = (item) => {
    const expires = new Date();
    expires.setHours(23, 59, 59, 0);
    setCookie(`hide${item.id}`, true, { expires });
    setShowPopup(false);
  };

  const _setClose = () => {
    if (isHidden) {
      handleHidePopup(item);
    }
    setShowPopup(false);
  };

  const _setHidden = () => {
    setIsHidden((prev) => !prev);
  };

    const sliderSettings = {
      dots: true,
      infinite: true, // 무한 반복
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true, // 화살표 표시
      adaptiveHeight: true, // 높이에 맞춰 슬라이드 크기 조정
      autoplay: true, // 자동으로 슬라이드 전환
      autoplaySpeed: 2000, // 슬라이드 간 자동 전환 시간 (밀리초 단위, 여기서는 2초)
      afterChange: (index: number) => {
            setCurrentIndex(index); // 슬라이드 변경 시 인덱스 업데이트
      }
    };

  if (showPopup && !cookies[`hide${item.id}`]) {
    return (
      <Modal
        isOpen={showPopup && !cookies[`hide${item.id}`]}
        isCentered
        closeOnOverlayClick={false}
        closeOnEsc={false}
        onClose={_setClose}
      >
        <ModalOverlay bg="blackAlpha.300" backdropFilter="blur(3px)" />
        <ModalContent w={screen === "mobile" ? "80vw" : "420px"} background="transparent" boxShadow={0}>
          <ModalBody position="relative" borderRadius="22px" p={0}>
            <div style={{ width: "100%", height: "auto" }}>
              <CustomSlider {...sliderSettings}>
                {images.map((src, index) => (
                  <div key={index} style={{ position: "relative" }}>
                  <Image key={index} src={src} w="100%" h="auto" borderRadius="22px" alt={`popup-image-${index}`} />
                  {/* 특정 이미지에만 버튼 추가 */}
                  {/*
                      {index === currentIndex && (
                        <Flex position="absolute" bottom="10px" left="50%" transform="translateX(-50%)">
                          <Button
                            colorScheme="teal"
                            onClick={() => window.open("http://t-assi.co.kr/")}
                          >
                            버튼 {index + 1}
                          </Button>
                        </Flex>
                      )}
                  */}
                    {/* 특정 이미지에만 버튼 추가 */}
                      {0 === currentIndex && (
                          <>
                              <Link key={1} to="/testops" state={{ data: AitestMenu }}>
                                  <Button
                                      position={"absolute"}
                                      top={"81.5%"}
                                      left={"21.4%"}
                                      w={"8.2%"}
                                      h={"9.6%"}
                                      p={0}
                                      borderRadius={"10px"}
                                      background={"transparent"}
                                      cursor={"pointer"}
                                      _hover={{ background: "transparent" }}
                                      _focusVisible={{ boxShadow: "none" }}
                                  />
                              </Link>
                              <Button
                                  position={"absolute"}
                                  top={"81.5%"}
                                  left={"30.4%"}
                                  w={"8.2%"}
                                  h={"9.6%"}
                                  p={0}
                                  borderRadius={"10px"}
                                  background={"transparent"}
                                  cursor={"pointer"}
                                  _hover={{ background: "transparent" }}
                                  _focusVisible={{ boxShadow: "none" }}
                                  onClick={() => window.open("https://www.etnews.com/20241029000038")}
                              />
                          </>
                        )}
                      {1 === currentIndex && (
                        <Button
                            position={"absolute"}
                            top={"49.5%"}
                            left={"41.98%"}
                            w={"9%"}
                            h={"9.25%"}
                            p={0}
                            borderRadius={"39px"}
                            background={"transparent"}
                            cursor={"pointer"}
                            _hover={{ background: "transparent" }}
                            _focusVisible={{ boxShadow: "none" }}
                            onClick={() => window.open("http://t-assi.co.kr/")}
                          />
                      )}
                   </div>
                ))}
              </CustomSlider>
            </div>
            <Flex position="absolute" top={0} left={0} w="100%" h="10%" justifyContent="end" p="10px">
              <BtnClose onClick={_setClose} />
            </Flex>
          </ModalBody>
          <ModalFooter background="transparent" justifyContent="start" p="10px 0 0 0">
            <Check id="ck_hidden" type="checkbox" onChange={_setHidden} checked={isHidden} />
            <Label htmlFor="ck_hidden" $size="23px">
              {isHidden && <IconCheck />}
            </Label>
            <Text color="#A5A5A5" fontSize="12px" cursor="pointer" onClick={_setHidden}>
                오늘 하루 보지 않기
              </Text>
            </ModalFooter>
          </ModalContent>
        </Modal>
      );
    } else {
      return null;
    }
  };

export default PopupBanner;
